import { z } from 'zod';
import { recoveryRepairBootstrapDescriptorV1Schema } from '../recovery/hardening/repairBootstrap';
import type { MaintenanceTask } from './maintenanceTypes';

export const maintenanceRepairBootstrapSchema = z.object({
  descriptor: recoveryRepairBootstrapDescriptorV1Schema,
  transitionId: z.string().uuid(),
}).strict();

export function validateMaintenanceRepairBootstrap(task: MaintenanceTask, context: z.RefinementCtx): void {
  const operation = task.operation === 'bootstrap-repair';
  const artifact = task.artifact;
  const repair = artifact.repairBootstrap;
  if (!operation) {
    if (artifact.kind === 'immutable-recovery-repair' || repair !== undefined) {
      context.addIssue({ code: z.ZodIssueCode.custom, path: ['artifact'], message: 'Repair bootstrap metadata is operation-scoped' });
    }
    return;
  }
  if (task.context.kind !== 'machine-system' || task.context.sessionSid !== null || task.policy.hostMode !== 'any-mode'
      || task.rerunPolicy !== 'idempotent' || task.reconcileArtifact !== null || task.reconciliationFor !== undefined
      || artifact.kind !== 'immutable-recovery-repair' || !repair || artifact.targetVersion !== null || artifact.branch !== null
      || artifact.installerVersion !== undefined) {
    context.addIssue({ code: z.ZodIssueCode.custom, path: ['operation'], message: 'Invalid repair bootstrap execution scope' });
    return;
  }
  const parsed = maintenanceRepairBootstrapSchema.safeParse(repair);
  if (!parsed.success) {
    context.addIssue({ code: z.ZodIssueCode.custom, path: ['artifact', 'repairBootstrap'], message: 'Invalid repair bootstrap metadata' });
    return;
  }
  if (parsed.data.descriptor.payload.installerSha256 !== artifact.sha256
      || parsed.data.descriptor.payload.installerBytes !== String(artifact.byteLength)) {
    context.addIssue({ code: z.ZodIssueCode.custom, path: ['artifact'], message: 'Repair bootstrap descriptor does not bind artifact' });
  }
}
